
import React from "react";
import { Container } from "react-bootstrap";
import ReactPlayer from "react-player";

export default function HomeVideo() {
    return (
        <Container fluid className="p-0">
            <style>
                {`
                    .home-video {
                        width: 100%;
                        height: 600px;
                        background: #000;
                    }

                    .home-video iframe {
                        width: 100%;
                        height: 100%;
                    }
                `}
            </style>

            <div className="home-video">
                <ReactPlayer
                    url="https://www.youtube.com/watch?v=59Dh4eytZp0"
                    width="100%"
                    height="100%"
                    playing={true}
                />
            </div>
        </Container>
    );
}
